// Function that takes in an array of objects and returns a string of the content in rich text format
export const getPhysicalReqContent = (
  physicalRequirementsContent: {
    title: string
    content: string
  }[]
) => {
  return physicalRequirementsContent
    .map(
      (req) =>
        `<div margin-bottom: 4px;">
        <div>
          ${req.title}
        </div>
        <div>
          ${req.content}
        </div>
      </div>`
    )
    .join('')
}
